module.exports = __webpack_public_path__ + "static/media/cervical-ripening-balloon-stylet-product@2x.f22db9f2.jpg";